<template>
  <component
    :is="componentType"
    :href="href"
    :to="to"
    :href-lang="hrefLang"
    :rel="rel"
    :target="target"
    :class="`px-4 rounded border-none
      font-cera-pro font-medium text-base leading-5 text-center
      items-center justify-center no-underline outline-none
      cursor-pointer disabled:cursor-not-allowed ${classes}`"
    @click="handleClickEvent($event)"
    @click.native="handleClickEvent($event)"
  >
    <div v-if="icon" class="flex items-center justify-center text-center">
      <sprite :id="icon" class="w-6 h-6 mr-2" />
      <slot />
    </div>
    <slot v-else />
  </component>
</template>

<script>
import events from "@/bl-events"
import Sprite from "@/shared/sprite"

export const BUTTON_LINK_VARIANTS = {
  "conversion": "bg-green text-midnight hover:bg-green-2 hover:text-midnight",
  "product-interaction": "bg-midnight text-white hover:bg-deep-black hover:text-white"
}

export default {
  name: "ButtonLink",
  components: {
    Sprite
  },
  props: {
    variant: {
      type: String,
      default: "conversion",
      validator: (value) => {
        return Object.keys(BUTTON_LINK_VARIANTS).includes(value)
      }
    },
    href: { type: String, default: null },
    to: { type: String, default: null },
    hrefLang: { type: String, default: null },
    rel: { type: String, default: null },
    target: { type: String, default: null },
    icon: { type: String, default: null },
    eventCategory: { type: String, default: "body-20200305-cta" },
    eventName: { type: String, default: null }
  },
  computed: {
    componentType() {
      return this.to ? "router-link" : "a"
    },
    classes() {
      return `${BUTTON_LINK_VARIANTS[this.variant]} ${this.icon ? "py-2.5 block w-max" : "py-3"}`
    }
  },
  methods: {
    handleClickEvent(event) {
      if (this.eventName) {
        events.track(this.eventCategory, "1-click", this.eventName)
      } else {
        events.track(this.eventCategory, "1-click")
      }

      this.$emit("click", event)
    }
  }
}
</script>
